import React from 'react'
import { Icon } from '@therms/atalaya'
import { MobileMenuLink } from '@src/modules/Layout/shared/MobileMenuLink'
import { LOCATIONS_ROUTES } from '../../constants'
import { MdBusiness } from 'react-icons/md'

function LocationsMobileMenuLink() {
  return (
    <MobileMenuLink to={LOCATIONS_ROUTES.__ROOT__}>
      <div className="flex flex-col items-center">
        <Icon Icon={MdBusiness} />
        <span>Locations</span>
      </div>
    </MobileMenuLink>
  )
}

export { LocationsMobileMenuLink }
